import { z } from 'zod'
import { enumerated } from '~/prix/types/enumerated'
import { dateOrIsoString } from '~/prix/types/date'
import { ageRangesEnumeratedOptions } from '~/utils/shared/ageRanges'

export const citizenShapeBase = z.object({
  originalId: z.string().describe('ID original'),
  dataSourceId: z.number().describe('ID da fonte de dados'),
  cpf: z.string().describe('CPF').nullish(),
  cns: z.string().describe('CNS').nullish(),
  name: z.string().describe('Nome'),
  socialName: z.string().describe('Nome social').nullish(),
  birthDate: dateOrIsoString().describe('Data de nascimento'),
  age: z.number().describe('Idade'),
  ageDecimal: z.number().describe('Idade decimal'),
  ageRange: enumerated(ageRangesEnumeratedOptions).describe('Faixa etária'),
  sex: enumerated({
    male: 'Masculino',
    female: 'Feminino',
  }).describe('Sexo biológico'),
  genderIdentity: z.string().describe('Identidade de gênero').nullish(),
  phoneNumber: z.string().describe('Telefone').nullish(),
  deceased: z.boolean().describe('Falecido'),
  healthUnitCnes: z.string().describe('CNES da unidade de saúde').nullish(),
  teamIne: z.string().describe('INE da equipe').nullish(),

  /* Propriedades de localização do cidadão */
  streetName: z.string().describe('Nome da rua').nullish(),
  streetNumber: z.string().describe('Número da rua').nullish(),
  streetType: z.string().describe('Tipo de rua').nullish(),
  complement: z.string().describe('Complemento').nullish(),
  neighborhood: z.string().describe('Bairro').nullish(),
  referencePoint: z.string().describe('Ponto de referência').nullish(),
  postalCode: z.string().describe('CEP').nullish(),
  municipality: z.string().describe('Município').nullish(),
  state: z.string().describe('Estado').nullish(),
  deathDate: dateOrIsoString().describe('Data de óbito').nullish(),

  /* Propriedades de controle do cidadão */
  createdAt: dateOrIsoString().describe('Data de criação'),
  updatedAt: dateOrIsoString().describe('Data de atualização'),
})

export const citizenLocationShape = z.object({
  latitude: z.number().describe('Latitude').nullish(),
  longitude: z.number().describe('Longitude').nullish(),
  angleFromStreet: z.number().describe('Ângulo a partir da rua').nullish(),
})